import {
  isNewSiteFlow,
  ONBOARDING_COMPLETE_KEY,
  SITE_DRAFT_KEY,
  useOnboardingStore,
} from '~/stores/useOnboardingStore'
import { useAuthStore } from '~/stores/useAuthStore'
import { useBuilderStore } from '~/stores/useBuilderStore'

/**
 * Guard for /builder and /onboarding routes.
 * - /builder without a draft → /onboarding
 * - completed onboarding → /builder
 *
 * localStorage is client-only, so draft checks run on the client.
 */
export default defineNuxtRouteMiddleware((to) => {
  // Skip on server — Pinia + localStorage hydration happens client-side.
  if (import.meta.server) return

  const onboarding = useOnboardingStore()
  if (!onboarding.hydrated) {
    onboarding.hydrateFromStorage()
  }
  const auth = useAuthStore()

  const hasDraft =
    onboarding.completed ||
    !!localStorage.getItem(SITE_DRAFT_KEY) ||
    localStorage.getItem(ONBOARDING_COMPLETE_KEY) === '1'

  if (to.path.startsWith('/builder')) {
    const { loggedIn } = useUserSession()
    if (loggedIn.value) return

    const builder = useBuilderStore()
    if (!hasDraft && !builder.siteData) {
      return navigateTo('/onboarding')
    }
  }

  // A completed site should never be sent back into onboarding. Creating another
  // site explicitly sets NEW_SITE_KEY and is the only flow allowed through.
  const hasExistingSite = auth.hydrated && (!!auth.site || auth.sites.length > 0)
  if (!isNewSiteFlow() && to.path.startsWith('/onboarding')) {
    if (onboarding.completed) return navigateTo('/builder')
    if (hasExistingSite) return navigateTo('/dashboard')
  }
})
